import { gsap } from 'gsap';
import { initMouseHighlight } from './mouseHighlight.js';
import { initHomeLottie } from './homeLottie.js';

export function homePanelsSlideIn() {

    const panels = document.querySelectorAll('.home-panel-column');
    if (panels.length === 0) {
        return;
    }

    const tl = gsap.timeline({
        onComplete: () => {
            initHomeLottie();
            initMouseHighlight();
        }
    });

    tl.to(panels, {
        y: 0,
        duration: 1.2,
        ease: 'cubic-bezier(.5,-0.53,.14,1.23)',
    }, 0);
}

document.addEventListener('DOMContentLoaded', () => {
    homePanelsSlideIn();
});